/**
 * @generated SignedSource<<44e38621550cc9151612becdd68b8af1>>
 * @relayHash 146848d898d4f1b4f17c6ffe7e519e02
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 81e1bc983c19feae9a62b87e16c21b378ccf00340edc9840ae4d1e14b946f849

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type usePublishRealtimeChannelMutation$variables = {
  context?: string | null | undefined;
  installationId: string;
  isGlobal?: boolean | null | undefined;
  name: string;
  payload: string;
  token?: string | null | undefined;
};
export type usePublishRealtimeChannelMutation$data = {
  readonly ecosystem: {
    readonly publishRealtimeChannel: {
      readonly eventId: string | null | undefined;
      readonly eventTimestamp: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type usePublishRealtimeChannelMutation = {
  response: usePublishRealtimeChannelMutation$data;
  variables: usePublishRealtimeChannelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "installationId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGlobal"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "payload"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v6 = [
  {
    "concreteType": "EcosystemMutation",
    "kind": "LinkedField",
    "name": "ecosystem",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "context",
            "variableName": "context"
          },
          {
            "kind": "Variable",
            "name": "installationId",
            "variableName": "installationId"
          },
          {
            "kind": "Variable",
            "name": "isGlobal",
            "variableName": "isGlobal"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "payload",
            "variableName": "payload"
          },
          {
            "kind": "Variable",
            "name": "token",
            "variableName": "token"
          }
        ],
        "concreteType": "EcosystemRealtimePublishBody",
        "kind": "LinkedField",
        "name": "publishRealtimeChannel",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "eventId"
          },
          {
            "kind": "ScalarField",
            "name": "eventTimestamp"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "usePublishRealtimeChannelMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePublishRealtimeChannelMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "id": "81e1bc983c19feae9a62b87e16c21b378ccf00340edc9840ae4d1e14b946f849",
    "metadata": {},
    "name": "usePublishRealtimeChannelMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e82f2888e170470f31e8c75c07be4439";

export default node;
